import { FC, useMemo } from 'react'
import styles from 'components/features/coaching/advisor/AdvisorDetailsPane/AdvisorDetailsPane.styl'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { MeetingUid } from 'components/features/coaching/advisorPage/types/interfaces'
import { FloatingPaneLayout } from 'components/features/pfm/FloatingPaneLayout/FloatingPaneLayout'
import { FloatingPaneFooter } from 'components/features/pfm/FloatingPaneFooter/FloatingPaneFooter'
import { FloatingPaneHeader } from 'components/features/pfm/FloatingPaneHeader/FloatingPaneHeader'
import { createAdvisorSelector } from 'components/features/coaching/advisorMeeting/selectors/advisorsSelector'
import { AdvisorHeaderWith } from 'components/features/coaching/advisor/AdvisorHeaderWith/AdvisorHeaderWith'
// import SvgIcon from 'components/atoms/SvgIcon'
// import StarSvg from 'icons/star.svg'

type AdvisorDetailsPaneProps = {
  uid: MeetingUid
  onClose: () => void
  onBack: () => void
}
export const AdvisorDetailsPane: FC<AdvisorDetailsPaneProps> = (props) => {
  const { uid, onClose, onBack } = props

  const advisorSelector = useMemo(createAdvisorSelector, [])
  const advisor = useStoreSelector((state) => advisorSelector(state, props))
  const isLoading = useStoreSelector((state) => state.data.advisors.advisorsRequest.isLoading)

  if (!advisor) {
    return <></>
  }

  const { name } = advisor

  const reviewsChild = null
  // const reviewsChild = reviews.map((review, index) => {
  //   const ratingStars = [...Array(review.rating)].map((_e, i) => {
  //     return <li key={ i }><i><SvgIcon src={ StarSvg } /></i></li>
  //   })
  //   return (
  //     <div className={ styles.review } key={ index }>
  //       Review
  //       <ul className={ styles.stars }>
  //         { ratingStars }
  //       </ul>
  //       <h5>{ review.username }</h5>
  //       <p>{ review.text }</p>
  //     </div>
  //   )
  // })

  const header = (
    <FloatingPaneHeader
      title={ name }
      iconSlug='coaching'
      withCircledIcon
      centered
      onAction={ onBack }
    />
  )

  const footer = (
    <FloatingPaneFooter
      isLoading={ isLoading }
      actionName='Back'
      onAction={ onBack }
      cancelName=''
      onCancel={ onBack }
    />
  )

  return (
    <FloatingPaneLayout
      type='future'
      header={ header }
      notification={ footer }
      withStaticHeader
      bodyClassName={ styles.advisorDetailsPane }
      onClose={ onClose }
    >
      <AdvisorHeaderWith uid={ uid } showRating />
      <div>Advisor reviews go here...</div>
      { reviewsChild }
    </FloatingPaneLayout>
  )
}
